import React from "react";
import { useNavigate } from "react-router-dom";
import checkbox from "../assets/images/marksuccess.svg";
import rejectimg from "../assets/images/cancelsuccess.svg";
import loader from "../assets/images/load.svg";
import documentIcon from "../assets/images/document-text.svg";

const DocumentUploaderViewer = ({
  label,
  id,
  documentKey,
  documentGroup,
  businessId,
  businessType,
  onUpload,
}) => {
  const navigate = useNavigate();
  var documentData =
    documentGroup?.LLC?.[documentKey] ||
    documentGroup?.SoleProprietorship?.[documentKey];

    if(documentKey === "CERTIFICATE_OF_INCORPORATION" && !documentData?.url){
      documentKey = "CAC";
     documentData = documentGroup?.LLC?.[documentKey] || 
     documentGroup?.SoleProprietorship?.[documentKey];
    }

  const handleClick = () => {
    if (documentData?.url && documentData?.status !== "REJECTED") {
      navigate("/verifyDocument", {
        state: {
          documents: documentGroup?.LLC || documentGroup?.SoleProprietorship,
          image: documentData?.url,
          type: documentKey,
          id: businessId,
          businessType: businessType,
        },
      });
    } else {
      document.getElementById(id)?.click();
    }
  };

  const getStatusIcon = () => {
    const status = documentData?.status;
    if (status === "APPROVED") return checkbox;
    if (status === "REJECTED") return rejectimg;
    return loader;
  };

  return (
    <div
      className="each_sec_lg_vg"
      style={{
        border: "1px solid #e7e9fb",
        cursor: "pointer",
      }}
      onClick={handleClick}
    >
      <div className="lg-md-lf-glv">
        <img src={documentIcon} alt="" />
        {label}
      </div>

      {documentData?.url ? (
        <span className="material-icons">navigate_next</span>
      ) : (
        <span className="not-uploaded-label">Not uploaded</span>
      )}

      <input
        id={id}
        type="file"
        accept=".jpg,.jpeg,.png,.pdf"
        style={{ display: "none" }}
        onChange={(e) => onUpload(e, documentKey)}
      />

      <div className="loader">
        <img src={getStatusIcon()} alt="" />
      </div>
    </div>
  );
};

export default DocumentUploaderViewer;
